import { Column, EditType } from '@src/model/table';
import { ActionType } from '@src/utils/enums';
import { Domain } from '@src/dtos/version.dto';
import { isDomainValid, isValueDuplicate } from '@src/utils/validationUtils';
import { createDescriptionColumn, createDomainActionColumn } from '@src/components/shared/table/column-factories';
import { useStores } from '@src/components/store';

export const useDomainsColumns = () => {
    const { fwVersionBronzeStore } = useStores();

    return [
        {
            accessor: 'domainUrl',
            header: 'Domain',
            width: '300px',
            displayOnEdit: true,
            type: EditType.Text,
            getPlaceholder: () => 'Enter domain',
            validationRules: [isValueDuplicate, isDomainValid],
            mandatory: true,
            description: 'Only main domains like example.com are supported; no subdomains or paths.',
            maxLength: 50
        },
        {
            ...createDomainActionColumn(),
            disableEdit: (row) => {
                if (row.domainAction === ActionType.ALLOW) {
                    return fwVersionBronzeStore.hasReachedDomainLimitFor(ActionType.BLOCK);
                }

                return fwVersionBronzeStore.hasReachedDomainLimitFor(ActionType.ALLOW);
            }
        },
        createDescriptionColumn(520, 100)
    ] as Column<Domain>[];
};
